<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" @submit.native.prevent :label-width="labelWidth">
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005383')" prop="carrierName">
              <Input v-model.trim="pageParams.carrierName" clearable></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="510"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--物流渠道弹窗-->
    <supplierLogisticsChannels
      optionsType="thirdPartyLogistics"
      ref="logisticsChannelsDrawer"
      @updateData="pageParamsStatus = true">
    </supplierLogisticsChannels>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {isValueEmpty} from "@/utils/common";
import supplierLogisticsChannels from "@/views/supplier/components/warehouseLogistics/supplierLogisticsChannels.vue";

export default {
  name: 'thirdPartyLogisticsList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        carrierName: '',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005379'),
          key: 'carrierName',
          minWidth: 150,
          align: 'center',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 200,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                align: 'center',
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005257'),
                    show: v.getPermission('carrierShippingMethod_api_queryForEnableShippingMethods'),
                    clickFn: () => {
                      v.$refs['logisticsChannelsDrawer'].getSupplierLogisticsChannelData(params.row);
                    }
                  }
                ]
              }
            });
          }
        }
      ],
      tableData: [],
    };
  },
  created() {
    this.reset();
    this.search();
  },
  methods: {
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置数据
    reset() {
      let v = this;
      v.$nextTick(() => {
        v.$refs['pageParams'].resetFields();
        v.search();
      });
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsSupplierCarrier_queryForThirdCarriersPage')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsSupplierCarrier_queryForThirdCarriersPage, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    supplierLogisticsChannels
  }
};
</script>

<style lang="less">

</style>
